import styled from "@emotion/styled";
import { MODAL_BACKGROUND } from "/constants/z-index";
export const StyledProductFeatureName = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: ${({ isNewPricing })=>isNewPricing ? '24px 0' : '16px 0'};
    color: #676879;
    justify-content: space-between;
    font-weight: 400;
    font-size: 0.844rem;
    border-bottom: ${({ isNewPricing })=>isNewPricing ? '1px solid #C3C6D4' : 'none'};

    .icon {
        position: relative;
        margin-left: 6px;

        .tooltip {
            z-index: ${MODAL_BACKGROUND};
            display: none;
            opacity: 0;
            position: absolute;
            bottom: calc(100% + 16px);
            transform: translateX(-50%);
            transition: opacity 0.2s ease;
            width: 300px;

            .floating-tooltip {
                position: relative;
                white-space: normal;
                text-align: left;
                top: 100%;
                left: 50%;
            }
        }

        &:hover {
            .tooltip {
                display: block;
                opacity: 1;
            }
        }
    }

    ${({ isCrmClassic })=>isCrmClassic ? `
    color: #323338;
    &.tooltip-on-text .name-label {
        position: relative;
        cursor: default;
        display: inline-flex;
        align-items: center;

        .tooltip {
            z-index: ${MODAL_BACKGROUND};
            display: none;
            opacity: 0;
            position: absolute;
            bottom: calc(100% + 12px);
            left: 0;
            transition: opacity 0.2s ease;
            width: 260px;

            .floating-tooltip {
                position: relative;
                white-space: normal;
                text-align: left;
            }
        }

        &:hover .tooltip {
            display: block;
            opacity: 1;
        }
    }
    ` : ""}
`;
export const StyledProductFeatureValue = styled.div`
  font-size: 0.875rem;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 16px 16px;
  border-bottom: ${({ isNewPricing })=>isNewPricing ? '1px solid #C3C6D4' : 'none'};

  &.check-circle {
    path {
      fill: #676879;
    }
  }

  &.empty-feature-value {
    border-bottom: ${({ isNewPricing })=>isNewPricing ? '1px solid #C3C6D4' : 'none'};
  }
`;
